/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Col_PcInputs */

const en_pc_cmp_col_pc = /** @type {(inputs: Pc_Cmp_Col_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft`)
};

const zh_pc_cmp_col_pc = /** @type {(inputs: Pc_Cmp_Col_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft`)
};

/**
* | output |
* | --- |
* | "PdfCraft" |
*
* @param {Pc_Cmp_Col_PcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_col_pc = /** @type {((inputs?: Pc_Cmp_Col_PcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Col_PcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_col_pc(inputs)
	return zh_pc_cmp_col_pc(inputs)
});
export { pc_cmp_col_pc as "pc.cmp.col_pc" }